import toast from 'react-hot-toast';
import { Services } from '../../types/services';

// Interfaces
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface State {
  // Empty state
}

interface Action {
  type: string;
  payload?: unknown;
}

const initialState: State = {
  // Empty state
};

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosCall = services.axios.Axios();

  const getAccounts = () => async () => {
    try {
      const response = await axiosCall.get<{ data: unknown }>('accounts');
      return response.data;
    } catch (err) {
      console.error(err);
    }
  };

  const getAccount = (accountId: string) => async () => {
    try {
      const response = await axiosCall.get<{ data: unknown }>('accounts/' + accountId);
      return response.data;
    } catch (error) {
      const errorMsg = (error as Error).message;
      toast.error('Error: Something went wrong fetching this account ' + errorMsg);
      return error;
    }
  };

  const createAccount = (payload: Record<string, unknown>) => async () =>
    axiosCall
      .post('accounts', { ...payload })
      .then(res => res.data)
      .catch(error => {
        throw error;
      });

  const updateAccount = (id: string, payload: Record<string, unknown>) => async () => {
    await axiosCall.patch('accounts/' + id, {
      ...payload,
    });
  };

  const getAccountsToAssignPartner = (partnerId: string) => async () =>
    axiosCall.get('accounts/withPartnerDomains?partnerId=' + partnerId);

  const addAccountToPartner = (partnerId: string, accountId: string) => async () =>
    axiosCall.post(
      'accounts/addToPartner',
      {
        id: accountId,
      },
      { params: { partnerId: partnerId } },
    );

  const removeAccountFromPartner = (partnerId: string, accountId: string) => async () =>
    axiosCall.delete('accounts/deleteFromPartner', {
      params: { partnerId: partnerId, accountId: accountId },
    });

  return {
    addAccountToPartner,
    createAccount,
    getAccount,
    getAccounts,
    getAccountsToAssignPartner,
    removeAccountFromPartner,
    updateAccount,
  };
};
